import { render, staticRenderFns } from "./ServicePack.vue?vue&type=template&id=37839942"
import script from "./ServicePack.vue?vue&type=script&lang=ts"
export * from "./ServicePack.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37839942')) {
      api.createRecord('37839942', component.options)
    } else {
      api.reload('37839942', component.options)
    }
    module.hot.accept("./ServicePack.vue?vue&type=template&id=37839942", function () {
      api.rerender('37839942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/ServicePack.vue"
export default component.exports